import { useSnackbar } from 'notistack'
import { FC } from 'react'
import { IconButton } from '../../../__legacy__/components/core/Components'
import { Share } from '../../../__legacy__/components/core/icons/responsive-icons'
import { copyToClipboard } from '../../../__legacy__/components/core/Utils'

interface Props {
  textToCopy: string
}

export const ShareIconButton: FC<Props> = ({ textToCopy }) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleClick = () => {
    copyToClipboard(textToCopy)
    enqueueSnackbar('Sample pack link copied!', {
      variant: 'modalSuccess'
    })
  }

  return (
    <IconButton onClick={handleClick} css={{ padding: '8px' }}>
      <Share height="20px" width="20px" />
    </IconButton>
  )
}
